import React, { useState } from "react";
import {
  Card,
  CardContent,
} from "../../../components/ui/card";
import {
  FormatedDates,
} from "../../../services/helpers";
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "../../../components/ui/alerts";
import { Button } from "@material-ui/core";
import { ChevronLeft, ChevronRight, InfoIcon } from "lucide-react";

const ChangeHistory = ({ filterData, employeeData }) => {
  const [page, setPage] = useState(1);
  const itemsPerPage = 5;

  const changes = [...(filterData?.[0]?.changes || [])]?.sort(
    (a, b) => b.createdAt - a.createdAt
  );

  const totalPages = Math?.ceil(changes?.length / itemsPerPage);
  const startIndex = (page - 1) * itemsPerPage;
  const paginatedData = changes.slice(startIndex, startIndex + itemsPerPage);

  const handleNext = () => {
    if (page < totalPages) setPage((prev) => prev + 1);
  };

  const handlePrevious = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  return (
    <>
      {filterData?.length > 0 && (
        <Card className="bg-white mt-30 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
          <CardContent className="pt-0 pb-24 ph-24">
            <div className="mt-24 space-y-4">
              <h3 className="font-medium text-lg">Change History</h3>

              {paginatedData?.map((record, index) => {
                const employee = employeeData?.find(
                  (item) => item?.id === record?.changedBy
                );
                const fullName = employee
                  ? `${employee.firstName || ""} ${employee.lastName || ""}`.trim()
                  : "Unknown";

                return (
                  <Alert
                    key={index}
                    className="dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]"
                  >
                    <InfoIcon className="h-4 w-4" />
                    <AlertTitle>
                      {index === 0 && page === 1
                        ? "Latest Change"
                        : "Previous Change"}
                    </AlertTitle>
                    <AlertDescription className="text-sm">
                      <div>
                        <strong>Changed by:</strong> {fullName}
                      </div>
                      <div>
                        <strong>Date:</strong>{" "}
                        {FormatedDates(record.createdAt)}
                      </div>
                      <div>
                        <strong>Changed from:</strong>{" "}
                        {typeof record.oldIndustry === "string"
                          ? record.oldIndustry
                          : record.oldIndustry?.title}
                      </div>
                      <div>
                        <strong>Changed to:</strong>{" "}
                        {record.industry?.title || "—"}
                      </div>
                    </AlertDescription>
                  </Alert>
                );
              })}

              {totalPages >= 1 && (
                <div className="flex justify-end items-center gap-4 mt-24">
                   <Button
                        variant="outlined"
                        size="small"
                        onClick={handlePrevious}
                        disabled={page === 1}
                        startIcon={<ChevronLeft className="w-4 h-4 dark:text-white" />}
                    />

                  <span className="text-sm">
                    Page {page} of {totalPages}
                  </span>
                   <Button
                        variant="outlined"
                        size="small"
                        onClick={handleNext}
                        disabled={page === totalPages}
                        endIcon={<ChevronRight className="w-4 h-4 dark:text-white" />}
                    />
                </div>
              )}
            </div>
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default ChangeHistory;
